import { CRUDProvider } from 'components/providers';
import { useTranslation } from 'react-i18next';
import { SitiResource } from 'services/resources/siti';

import { Page } from './components/Page';

export const SitiPage: React.FC = (): JSX.Element => {
  const { t } = useTranslation('siti');
  return (
    <CRUDProvider
      allowPost
      allowRemoveFilters
      quote={t('page.quote')}
      resource={SitiResource}
      searchBy="code__name"
      title={t('page.title')}
    >
      <Page />
    </CRUDProvider>
  );
};
